module.exports = __webpack_public_path__ + "727c4a7b5a195748535bdebff3439589.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/moonl.woff
// module id = 135
// module chunks = 0